import * as React from 'react';

import { GetTheApp } from '@bumble/ui-kit';
import common from 'components/lexemes/common';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import { onClickDownloadNowCta } from 'containers/events';

export const LandingGetTheAppContainer: React.FC = () => {
  const isMobile = useMediaQuery(MediaQueryWidth['desktop-md']);

  return (
    <GetTheApp
      title={common.lxGetTheAppTitle}
      description={
        isMobile ? common.lxGetTheAppDescriptionMobile : common.lxGetTheAppDescriptionDesktop
      }
      cta={{
        text: common.lxGetTheAppCta,
        href: 'https://bumble.onelink.me/3396940749/yuhjm82c',
        onClick: onClickDownloadNowCta,
      }}
    />
  );
};
